import { AttributeValue } from "./AttributeValue";
import { ElementSelector } from "./ElementSelector";
import { ElementType } from "./ElementType";

export class ElementSelectors
{
  static readonly inputCheckBox = new ElementSelector( ElementType.input, AttributeValue.type_checkbox );
}